import './NavbarActions.scss';
import { LanguagePicker } from '../LanguagePicker/LanguagePicker';
import LogoutButton from '../LogoutButton/LogoutButton';

export function NavbarActions() {
  return (
    <div className="navbar-actions">
      <LanguagePicker />
      <LogoutButton />
    </div>
  );
}
